<template>
  <div class="good-person">
    <div style="height: 20px"></div>
    <!-- <div class="good-title"> -->
      <div class="weekBox">
        <div class="weekTop">
          <P class="weekItem">序号</P>
          <P class="weekItem">姓名</P>
          <P class="weekItem">标题</P>
          <P class="weekItem">类别</P>
          <P class="weekItem">点赞</P>
        </div>
        <div style="height: 160px; overflow-y: auto">
          <div class="weekTops" v-for="(item, index) in list" :key="index" >
            <P class="weekItem">{{ Number(index) + 1 }}</P>
            <P class="weekItem">{{ item.name }}</P>
            <P class="weekItem">{{ item.deeds }}</P>
            <P class="weekItem">{{ item.categoryName }}</P>
            <P class="weekItem">{{ item.numberLikes }}</P>
          </div>
        </div>
      </div>
      <!-- <div>
                <vue-seamless-scroll
                    :data="list"
                    :class-option="classOption"
                    class="seamless-warp"
                >
                    <div
                        v-for="(item, index) in list"
                        :key="index"
                        @click="personInfo(item)"
                        class="good-list"
                    >
                        <div>{{ index + 1 }}</div>
                        <div :title="item.deeds">
                            {{ item.name }}--{{ item.deeds }}
                        </div>
                    </div>
                </vue-seamless-scroll>
            </div> -->
    <!-- </div> -->
    <el-dialog
      title="好人详情"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="40%"
      class="dialog_container"
      @close="dialogVisibleClone"
      :close-on-click-modal="false"
    >
      <div class="infoBox">
        <img :src="dataInfo.photo" v-if="dataInfo.photo" class="photo" />
        <img src="../../assets/img/user.png" class="photo" v-else />
        <div class="infoFlex">
          <p class="name">
            <span>姓名：{{ dataInfo.name }}</span>
          </p>
          <p class="name">
            <span>标题：{{ dataInfo.deeds }}</span>
          </p>
          <p class="time">
            <span>时间：{{ dataInfo.time }}</span>
          </p>
          <p class="type">
            <span>类别:{{ dataInfo.categoryName }}</span>
          </p>
          <p class="star">
            <span>点赞：{{ dataInfo.numberLikes }}票</span>
          </p>
        </div>
      </div>
      <quill-editor
        ref="text"
        v-model="dataInfo.characterStory"
        class="myQuillEditor"
        :options="editorOption"
        disabled
      />
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
  data() {
    return {
      list: [
        // {
        //   name:"李月梅",
        //   deeds:"帮助老人",
        //   categoryName:"助人为乐",
        //   numberLikes:"10"
        // },
        // {
        //   name:"蒋健",
        //   deeds:"给老让座",
        //   categoryName:"孝老爱亲",
        //   numberLikes:"17"
        // },
        // {
        //   name:"何月欣",
        //   deeds:"扶起摔倒老人",
        //   categoryName:"助人为乐",
        //   numberLikes:"13"
        // },
        // {
        //   name:"贺箫",
        //   deeds:"热心公益事业，多次参加捐款捐物活动",
        //   categoryName:"助人为乐",
        //   numberLikes:"12"
        // },
        //  {
        //   name:"江月",
        //   deeds:"诚心经营，不仅严格要求干净卫生，更选用上好原料",
        //   categoryName:"助人为乐",
        //   numberLikes:"14"
        // },
        //  {
        //   name:"付赫",
        //   deeds:"值班记录、操作指令、调试安排井井有条，准确无误",
        //   categoryName:"见义勇为",
        //   numberLikes:"7"
        // },
        //  {
        //   name:"贺箫",
        //   deeds:"见他人落水，义无反顾救人",
        //   categoryName:"见义勇为",
        //   numberLikes:"21"
        // }
      ],
      editorOption: {
        placeholder: "暂无信息",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],

              [
                {
                  header: 1,
                },
                {
                  header: 2,
                },
              ], // custom button values
              [
                {
                  list: "ordered",
                },
                {
                  list: "bullet",
                },
              ],
              [
                {
                  script: "sub",
                },
                {
                  script: "super",
                },
              ], // superscript/subscript
              [
                {
                  indent: "-1",
                },
                {
                  indent: "+1",
                },
              ], // outdent/indent
              [
                {
                  direction: "rtl",
                },
              ], // text direction

              [
                {
                  size: ["small", false, "large", "huge"],
                },
              ], // custom dropdown
              [
                {
                  header: [1, 2, 3, 4, 5, 6, false],
                },
              ],

              [
                {
                  color: [],
                },
                {
                  background: [],
                },
              ], // dropdown with defaults from theme
              [
                {
                  font: [],
                },
              ],
              [
                {
                  align: [],
                },
              ],
              ["image"],
              ["clean"], // remove formatting button
            ], // 工具栏
            // handlers: {
            //   image: value => {
            //     if (value) {
            //       document.querySelector(`.${this.editref}File`).click();
            //     } else {
            //       this.quill.format("image", false);
            //     }
            //   }
            //   //   upload: value => {
            //   //     if (value) {
            //   //       alert("自定义文件上传");
            //   //     }
            //   //   }
            // }
          },
        },
      },
      dataInfo: {},
      dialogVisible: false,
    }
  },
  computed: {
    classOption() {
      return {
        direction: 0,
        step: 0.3,
      }
    },
  },
  created() {
    this.getPeron()
  },
  mounted() {},
  methods: {
    dialogVisibleClone() {
      this.dialogVisible = false
    },
    // 获取详情
    personInfo(item) {
      this.dataInfo = {}
      this.dataInfo = item
      this.dialogVisible = true
      // console.log("详情", item)
    },
    // 好人信息
    getPeron() {
      request({
        url: "/sqyl/admin/goodPeopleRecommend/info/list",
        method: "POST",
        data: {
          auditStatus: "1",
          pageNo: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null) {
            this.list = []
            return
          }
          this.list = res.content.list
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.good-person {
  width: 400px;
  height: 25vh;
}
.good-title {
  width: 100%;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  color: #ffffff;
  font-size: 14px;
}

.seamless-warp {
  height: 210px;
  overflow: hidden;
}

.good-title > div:first-child {
  width: 70%;
}

.good-title > div:nth-child(2) {
  width: 20%;
}

.good-list {
  width: 100%;
  display: flex;
  align-items: center;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}

.good-list > div:first-child {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  line-height: 20px;
  text-align: center;
  background-color: #1999f7;
}

.good-list > div:nth-child(2) {
  width: 70%;
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.infoBox {
  display: flex;
  margin-bottom: 15px;
  .photo {
    width: 178px;
    height: 178px;
  }
  .infoFlex {
    flex: 1;
    font-size: 16px;
    line-height: 36px;
    margin-left: 20px;
  }
}
.weekBox{
    width: 100%;
   .weekTop {
        margin-top:20px; 
        display: flex;
        align-items: cneter;
        font-size: 13px;
        text-align: center;
        color: #fff;
        background: #1166a39d;
        line-height: 40px;
        justify-content: center;
    }
    .weekTops {
        display: flex;
        align-items: cneter;
        font-size: 13px;
        text-align: center;
        color: #fff;
        line-height: 40px;
        justify-content: center;
    }
 .weekEats {
    height: 72px;
    .weekEat {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 24px;
      color: #fff;
      height: 24px;
      font-size: 12px;
    }
  }
  .typeName {
    width: 60px;
    position: relative;
    text-align: center;
    font-size: 12px !important;
    color: #fff !important;
  }
  .weekItem {
    flex: 1;
    font-size: 12px !important;
    color: #fff !important;
    width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>
